import * as React from "react";

const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM16.6729 8.25977C16.2898 7.91162 15.7101 7.91651 15.333 8.25488L15.2598 8.32715L10.9648 13.0508L8.70703 10.793L8.63086 10.7246C8.23809 10.4043 7.65908 10.4269 7.29297 10.793C6.92685 11.1591 6.90426 11.7381 7.22461 12.1309L7.29297 12.207L10.293 15.207C10.4863 15.4003 10.7502 15.5064 11.0234 15.5C11.2968 15.4935 11.5563 15.3752 11.7402 15.1729L16.7402 9.67285L16.8047 9.59375C17.1062 9.18617 17.056 8.60812 16.6729 8.25977Z" fill="#42B677"/>
    <path d="M8 11.5L11 14.5L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default SVGComponent;

